import React, {useRef} from 'react'
import PageLayout from '../../../components/layout/PageLayout'
import useQueryReferrals from '../../../hooks/api/cashback/useQueryReferrals'
import TableHeader from '../../../components/table/TableHeader'
import Text from '../../../components/text/Text'
import TableLayout from '../../../components/table/TableLayout'
import TableItem from '../../../components/table/TableItem'
import WizImage from '../../../components/image/WizImage'
import useQueryExchanges from '../../../hooks/etc/useQueryExchanges'
import useNavigation from '../../../hooks/useNavigation'
import WizButton from '../../../components/button/WizButton'
import CreateReferralModal from '../../../features/page/cashback/CreateReferralModal'

interface IProps {
    className?: string
}

const ReferralPage: React.FC<IProps> = ({className}) => {
    const {data, refetch} = useQueryReferrals()
    const {data: exchanges} = useQueryExchanges()
    const {goPaybackDetail} = useNavigation()

    const arr = Array.isArray(data?.data)
        ? data.data?.filter(i => i?.exchange !== 'test')?.sort((a, b) => a?.exchange?.localeCompare(b?.exchange))
        : []
    const createReferralRef = useRef(null)

    return (
        <PageLayout title={'Referral'} className={className}>
            <WizButton
                text={'Create Referral Exchange'}
                type={'primary'}
                onClick={() => {
                    createReferralRef?.current?.show()
                }}
            />
            <TableHeader className={'grid-cols-5 sm:hidden mt-[20px]'}>
                <Text>Exchange</Text>
                <Text>Referral Code</Text>
                <Text>Cashback %</Text>
                <Text>Limit Order Fee</Text>
                <Text>Market Commission</Text>
            </TableHeader>
            <TableLayout className={'sm:mt-[20px]'}>
                {arr?.map(list => {
                    const me = exchanges?.find(exchange => {
                        if (exchange?.name === 'okex' && list?.exchange === 'okx') {
                            return true
                        }
                        return exchange?.name === list?.exchange
                    })
                    return (
                        <TableItem
                            key={list?.id}
                            className={'grid-cols-5 cursor-pointer'}
                            onClick={() => {
                                goPaybackDetail(list?.exchange)
                            }}>
                            <div
                                className={
                                    'flex items-center space-x-[10px] sm:flex-col sm:justify-center sm:text-center sm:gap-y-[10px]'
                                }>
                                <WizImage src={me?.icon || ''} className={'w-[24px]'} />
                                <div className={'flex items-center gap-x-[10px]'}>
                                    <Text className={'text-ti1'}>{me?.display_name}</Text>
                                    <div
                                        className={`w-[7px] h-[7px] rounded-full ${
                                            list?.status === 0
                                                ? 'bg-font04'
                                                : 'bg-blue-500 animate-[waveCircle_1.25s_ease-in_infinite]'
                                        }`}
                                    />
                                </div>
                            </div>
                            <div>
                                <Text className={'text-ti2 text-black'}>{list?.referral_code}</Text>
                            </div>
                            <div>
                                <Text className={'text-ti2 text-primary'}>{list?.max_reward_rate}%</Text>
                            </div>
                            <div>
                                <Text className={'text-body2'}>{list?.exchange_maker_fee_rate}%</Text>
                            </div>
                            <div>
                                <Text className={'text-body2'}>{list?.exchange_taker_fee_rate}%</Text>
                            </div>
                        </TableItem>
                    )
                })}
            </TableLayout>
            <CreateReferralModal
                ref={createReferralRef}
                callback={() => {
                    refetch()
                }}
            />
        </PageLayout>
    )
}

export default ReferralPage
